import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaDownload } from 'react-icons/fa';
import profileImg from '../assets/Teerth_coding_photo.jpg'; // Ensure the image path is correct

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-1/2"
        >
          <img
           src={profileImg}
           alt="Teerth Pandya"
            className="rounded-2xl shadow-2xl w-full h-auto object-cover"
          />
        </motion.div>

        {/* Content Section */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full md:w-1/2 space-y-6"
        >
          <h2 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
            About Me
          </h2>
          <p className="text-lg leading-relaxed text-gray-300">
            I'm a creative and passionate frontend developer focused on building beautiful and user-friendly websites.
            With a strong foundation in JavaScript, React, and UI design, I love crafting smooth interfaces and bringing ideas to life.
            I'm currently based in Kitchener, ON and always exploring new technologies and frameworks.
          </p>

          {/* Info Grid */}
          <div className="grid sm:grid-cols-2 gap-4 text-gray-300">
            <div className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-blue-400" />
              <span>Kitchener, Ontario, Canada</span>
            </div>
            <div className="flex items-center gap-2">
              <FaEnvelope className="text-blue-400" />
              <a href="teerthpandya2742002@gmail.com" className="hover:underline">
              teerthpandya2742002@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <FaPhoneAlt className="text-blue-400" />
              <a href="tel:+1234567890" className="hover:underline">
                +1 (382) 885-1842
              </a>
            </div>
            <div className="flex items-center gap-2">
              <FaDownload className="text-blue-400" />
              <a
                href="/Teerth_new_resume.pdf"
                download
                className="hover:underline"
              >
                Download Resume
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
